import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { Form } from '../../../../components/general/general-component/abstruct-component/AbstructForm';
import { loadCategories, postCategory } from '../../../../store/Actions/ActionCategory';
import { VariableSubCategory } from './VariableSubCategory';
import SelectDropDown from '../../../../components/elements/SelectDropDown';
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom';
import { postSubCategory } from '../../../../store/Actions/ActionSubCategory';

function AddSubCategory({ open, setOpen }) {
    const { categories, loadingCategories } = useSelectorCustom()
    const [option,setOption] = useState([])
    const { mode, dispatch, navigate, langLocal } = AbstructVar();

    const { translate } = AbstructLang();

    const { state, setStateCustom, setLoad } = VariableSubCategory();

    useEffect(() => {
        dispatch(loadCategories())
    }, []);
    useEffect(() => {
        setOption(categories?.map((category)=>({
            value: category?.id,
            label: category?.name
        })))
    }, [categories]);
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(postSubCategory(state, setLoad));
    };

    const formFields = [
        { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
        { name: 'description', label: 'description', type: 'text', inputType: 'text', iconType: "pencil" },
    ];

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: 'popupR',
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
                <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
                    <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('add-sub-category')}</p>
                </div>
                <div className='select-in-form' >
                    <p className={langLocal === 'ar'? "textAlignRight": ""} >{translate('category')}</p>
                    <SelectDropDown options={option}
                        varr={state.category}
                        setVarr={(value) => setStateCustom('category', value)} />
                </div>
                <div style={{marginTop: "-10px"}} >
                    <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} buttonLabel="add" />
                </div>
            </div>
        </RModal>
    );
}

export default AddSubCategory;